import { ApplicationStage } from '../types';

export const ApplicationStageMapper = {
  [ApplicationStage.PHONE_SCREEN]: 'Phone screen',
  [ApplicationStage.SUBMITTED]: 'Submitted',
  [ApplicationStage.INTERVIEW]: 'Interview',
  [ApplicationStage.OFFER_EXTENDED]: 'Offer extended',
  [ApplicationStage.OFFER_ACCEPTED]: 'Offer accepted',
  [ApplicationStage.HIRED]: 'Hired',
  [ApplicationStage.REJECTED]: 'Rejected',
  [ApplicationStage.NO_STAGE]: 'No stage'
};
